
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media-library",
      function () {
        return require("private-next-pages/media-library/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media-library"])
      });
    }
  